var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gotoVisible)?_c('div',{staticClass:"comp-goto-top",attrs:{"title":"返回顶部"},on:{"click":_vm.gotoTop}},[_c('span',{staticClass:"iconfont iconzuojiantou"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }